var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppTableControl',{attrs:{"no-filter":""},on:{"query-debounced":_vm.searchByName,"export-excel-clicked":function($event){return _vm.downloadDailyReport(1)},"export-pdf-clicked":function($event){return _vm.downloadDailyReport(2)}}})}
var staticRenderFns = []

export { render, staticRenderFns }